import {
  BeautyIcon,
  BodyArtIcon,
  HairIcon,
  HairAndBeautyIcon,
  BarberIcon,
  OtherIcon,
  PersonalTrainer,
  TutoringAndConsultingIcon,
  MassageAndSpaIcon,
  WellbeingIcon,
} from '@/components/icons/customIcons';

export function CategoryButton({ option, selected, onClick }) {
  const categoryIcons = {
    Beauty: BeautyIcon,
    Hair: HairIcon,
    'Hair & beauty': HairAndBeautyIcon,
    Wellbeing: WellbeingIcon,
    'Massage & spa': MassageAndSpaIcon,
    Barber: BarberIcon,
    'Body art': BodyArtIcon,
    'Personal trainer': PersonalTrainer,
    'Tutoring & consulting': TutoringAndConsultingIcon,
    Other: OtherIcon,
    'Group Fitness': OtherIcon,
  };

  const Icon = categoryIcons[option] || null;
  const baseClasses =
    'pl-3 pr-5 py-2 border rounded-lg flex items-center gap-1.5 text-midnight-700';
  const selectedClasses = 'bg-midnight-700 border-midnight-500 text-white';
  const unselectedClasses =
    'border-charcoal-200 bg-white transition [@media(hover:hover)]:[@media(pointer:fine)]:hover:border-midnight-500 [@media(hover:hover)]:[@media(pointer:fine)]:hover:shadow-button [@media(hover:hover)]:[@media(pointer:fine)]:hover:-translate-y-[4px] [@media(hover:hover)]:[@media(pointer:fine)]:hover:-translate-x-[4px]';

  return (
    <button
      type="button"
      className={`${baseClasses} ${selected ? selectedClasses : unselectedClasses}`}
      onClick={onClick}
      aria-pressed={selected}
    >
      {Icon && <Icon />}
      <span className={selected ? 'text-white' : 'text-charcoal-900'}>
        {option}
      </span>
    </button>
  );
}
